import React from 'react';
import dynamic from 'next/dynamic';

const SectionCertification = dynamic(() => import('./SectionCertification'));

const SectionCertificationLazy = ({ ...props }: { title: string }) => {
  return <SectionCertification {...props} />;
};

export default SectionCertificationLazy;
